exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__text___QZqWZ{color:#3B436C}\n", ""]);

// exports
exports.locals = {
	"text": "style-module__text___QZqWZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/InfoModal/style.module.scss
// module id = 1801
// module chunks = 0